<div class="details-header">
  <div class="header-row">
    <h1>Entnahme</h1>
  </div>

  <a (click)="location.back()" class="back-link">
    <mat-icon>arrow_back</mat-icon>
    Zurück
  </a>
</div>

@if ((trunk | async); as trunk) {
  <div class="form-box">
    <knust-data-table [disableNewButton]="true"
      (inputChanged)="takeStockInputs = $event"
      (notesChanged)="takeStockNotes = $event"
      (closeTrunkClick)="closingTrunk = true"
      (addArticleToTrunk)="addArticleToTrunk()"
      [disableEditing]="trunk.completed"
      [commandMap]="commandMap"
      [columnConfig]="columnConfig"
      [displayedColumns]="displayedColumns">
    </knust-data-table>
  </div>
  <div class="form-box">
    <div class="section-header">
      <h3>Notiz</h3>
      <mat-slide-toggle [formControl]="freeTextToggleControl">Freitext</mat-slide-toggle>
    </div>
    <div class="input-columns-container">
      <div class="input-column">
        <mat-form-field appearance="fill">
          <mat-label>Notiz zur Entnahme</mat-label>
          @if (freeTextToggleControl.value) {
            <textarea matInput placeholder="Benötigt für Reperatur bei Kunden..."
              [formControl]="noteControl"
              (ngModelChange)="noteChange = true"
            ></textarea>
          } @else {
            <mat-select placeholder="Notiz" #singleSelect [formControl]="trunkNoticeCtrl" (ngModelChange)="noteChange = true">
              <mat-option>
                <ngx-mat-select-search [formControl]="trunkNoticeFilterCtrl"></ngx-mat-select-search>
              </mat-option>
              @for (trunkNotice of filteredTrunkNotices | async; track trunkNotice) {
                <mat-option [value]="trunkNotice.id">
                  {{trunkNotice.label}}
                </mat-option>
              }
            </mat-select>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="save-note-row">
      <button mat-flat-button color="primary" (click)="saveNote()" [disabled]="!noteChange">
        Notiz speichern
        <mat-icon>save</mat-icon>
      </button>
    </div>
  </div>
}

<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Durchgeführte Abbuchungen
      </mat-panel-title>
    </mat-expansion-panel-header>

    <knust-data-table [disableNewButton]="true"
      [disableEditing]="true"
      [commandMap]="commandMapBookings"
      [columnConfig]="columnConfigBookings"
      [displayedColumns]="displayedColumnsBookings">
    </knust-data-table>

    <button mat-stroked-button (click)="resetTrunk()" color="warn" class="reset-trunk-btn" [disabled]="(trunk | async)?.completed">
      Alle Abbuchungen stornieren
      <mat-icon>restart_alt</mat-icon>
    </button>
  </mat-expansion-panel>
</mat-accordion>
